import React from 'react';
import { Button, Card, Alert } from 'react-bootstrap';
import { playNotificationSound, playWebAudioNotification, showVisualNotification } from '../providers/SalesNewOrderProvider';

const NotificationTest = () => {
  const testFileAudio = () => {
    console.log("Test du fichier audio...");
    playNotificationSound();
  };

  const testWebAudio = () => {
    console.log("Test de l'API Web Audio...");
    playWebAudioNotification();
  };

  const testVisualNotification = () => {
    console.log("Test de la notification visuelle...");
    showVisualNotification();
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <h5>🧪 Test des Notifications</h5>
      </Card.Header>
      <Card.Body>
        <Alert variant="info">
          <strong>Instructions :</strong> Utilisez ces boutons pour tester les différentes méthodes de notification.
          Assurez-vous que votre navigateur autorise la lecture audio.
        </Alert>

        <div className="d-flex gap-2 flex-wrap">
          <Button variant="primary" onClick={testFileAudio}>
            🔊 Test Fichier Audio
          </Button>

          <Button variant="secondary" onClick={testWebAudio}>
            🎵 Test Web Audio API
          </Button>

          <Button variant="warning" onClick={testVisualNotification}>
            👁️ Test Notification Visuelle
          </Button>
        </div>

        <div className="mt-3">
          <small className="text-muted">
            <strong>Note :</strong> Si le fichier audio ne fonctionne pas, l'API Web Audio sera utilisée automatiquement.
            Si aucune méthode audio ne fonctionne, une notification visuelle s'affichera.
          </small>
        </div>
      </Card.Body>
    </Card>
  );
};

export default NotificationTest;